import Vue from "vue";
import Vuex from "vuex";
import Cookies from "js-cookie";
import router from "@/router";
const baseUrlS = require("@/config/index.js");
import { logout } from "@/api/login";
import { Message } from "element-ui";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: Cookies.get("RLPC_TOKEN_Key"),
    user: Cookies.getJSON("RL_PCUSER"),
    headerSelect: "1", //系统选择
    // 路径、请求地址
    baseUrl: baseUrlS.baseUrl,
    orderStatus: {
      // {
      //   status:
      //     "1待支付  2 待审核  3 审核成功  4 驳回  5 待生效  6 保障中  7 已过期  8 已取消 9申请退款 10已退款 11待上传资料 12空缺 13保前审核"
      // },
      1: {
        text: "待支付",
        icon: "icon-zhifu",
        url: require("@/assets/images/product/stateblue_bg.png")
      },
      2: {
        text: "待审核",
        icon: "icon-a-01_daishenhe",
        url: require("@/assets/images/product/stateblue_bg.png")
      },
      3: {
        text: "审核成功",
        icon: "icon-daishengxiao",
        url: require("@/assets/images/product/stateblue_bg.png")
      },
      4: {
        text: "驳回",
        icon: "icon-bohui1",
        url: require("@/assets/images/product/statered_bg.png")
      },
      5: {
        text: "待生效",
        icon: "icon-daishengxiao1",
        url: require("@/assets/images/product/stateblue_bg.png")
      },
      6: {
        text: "保障中",
        icon: "icon-baozhangzhong",
        url: require("@/assets/images/product/stategreen_bg.png")
      },
      7: {
        text: "已过期",
        icon: "icon-gantanhao",
        url: require("@/assets/images/product/stategrey_bg.png")
      },
      8: {
        text: "已取消",
        icon: "icon-quxiao",
        url: require("@/assets/images/product/stateyellow_bg.png")
      },
      9: {
        text: "申请退款",
        icon: "icon-shenqingtuikuan",
        url: require("@/assets/images/product/stateblue_bg.png")
      },
      10: {
        text: "已退款",
        icon: "icon-shenqingtuikuan",
        url: require("@/assets/images/product/stateblue_bg.png")
      },
      11: {
        text: "待传资料",
        icon: "icon-shangchuan",
        url: require("@/assets/images/product/stateblue_bg.png")
      },
      13: {
        text: "保前审核",
        icon: "icon-a-01_daishenhe",
        url: require("@/assets/images/product/stateblue_bg.png")
      }
    }
  },
  getters: {
    token: state => {
      if (state.user) {
        return state.user.token;
      }
    }, //头像
    avatar: state => {
      if (state.user) {
        return state.user.avatar;
      }
    }, //名字
    name: state => {
      if (state.user) {
        return state.user.username;
      }
    }, //id
    id: state => {
      if (state.user) {
        return state.user.id;
      }
    }, //是否展示佣金
    isCanCommission: state => {
      if (state.user) {
        return state.user.isCanCommission;
      }
    }
  },
  mutations: {
    //添加token
    addToken(state, token) {
      state.token = token;
      Cookies.set("RLPC_TOKEN_Key", token);
    },
    //添加账户信息
    addUser(state, user) {
      state.user = user;
      Cookies.set("RL_PCUSER", user);
    },
    // 转跳登陆页
    goLogin(state, msg) {
      if (msg && state.isLog) {
        state.isLog = false;
        Message.error(msg);
      }
      state.user = "";
      state.token = "";
      Cookies.remove("RLPC_TOKEN_Key");
      Cookies.remove("RL_PCUSER");
      router.push("/login");
    }
  },
  actions: {
    // 退出
    logout(context) {
      let _data = {};
      logout(_data)
        .then(function(res) {
          if (res.code == 1) {
            context.state.user = "";
            context.state.token = "";
            Cookies.remove("RLPC_TOKEN_Key");
            Cookies.remove("RL_PCUSER");
            Cookies.remove("storageNotice"); //去除公告弹窗记录
            router.push("/login");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },
  modules: {}
});
